

export class ExpenseTypeUpdateInput implements IExpenseTypeUpdateInput {
    /** The auto-generated id of the expense type master */
    expenseTypeId!: number;
    /** The expense type name with 255 character limit */
    expenseTypeName!: string;

    constructor(data?: IExpenseTypeUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expenseTypeId = _data["expenseTypeId"];
            this.expenseTypeName = _data["expenseTypeName"];
        }
    }

    static fromJS(data: any): ExpenseTypeUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseTypeUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expenseTypeId"] = this.expenseTypeId;
        data["expenseTypeName"] = this.expenseTypeName;
        return data; 
    }
}

export interface IExpenseTypeUpdateInput {
    /** The auto-generated id of the expense type master */
    expenseTypeId: number;
    /** The expense type name with 255 character limit */
    expenseTypeName: string;
}

